{
  "title": "Sudden Awakening (UA)",
  "source": "Unearthed Arcana 36 - Starter Spells",
  "levelAndSchool": "1st-level enchantment",
  "level": 1,
  "castingTime": "1 bonus action",
  "range": "10 feet",
  "components": "V",
  "duration": "Instantaneous",
  "description": [
    "Each sleeping creature you choose within range awakens, and then each prone creature within range can stand up without expending any movement."
  ],
  "spellLists": ["bard", "ranger", "arcane-trickster", "sorcerer", "wizard"]
}
